import { useState } from 'react';
import { Download, Share, SquarePlus } from 'lucide-react';
import { useInstall } from '../lib/pwa';
import { useI18n } from '../i18n';
import { Modal } from './ui';

/** "Install the app": native prompt on Android/Chromium, instructions on iOS/others. */
export function InstallButton({ className = 'btn', label, appName = 'Pizza Fornavia' }: { className?: string; label?: string; appName?: string }) {
  const { install, installed, ios } = useInstall();
  const { t } = useI18n();
  const [help, setHelp] = useState(false);
  if (installed) return null;
  return (
    <>
      <button
        className={className}
        data-testid="install-button"
        onClick={async () => {
          const r = await install();
          if (r === 'manual') setHelp(true);
        }}
      >
        <Download size={18} /> {label ?? t.install.button}
      </button>
      {help && <InstallHelp ios={ios} appName={appName} onClose={() => setHelp(false)} />}
    </>
  );
}

export function InstallHelp({ ios, appName, onClose }: { ios: boolean; appName: string; onClose: () => void }) {
  const { t } = useI18n();
  return (
    <Modal title={t.install.helpTitle} onClose={onClose} testId="install-help">
      <div className="stack">
        {ios ? (
          <>
            <p>{t.install.iosIntro}</p>
            <ol className="stack" style={{ paddingLeft: 20, margin: 0 }}>
              <li>{t.install.iosStep1(<Share size={16} style={{ verticalAlign: 'middle' }} />)}</li>
              <li>{t.install.iosStep2(<SquarePlus size={16} style={{ verticalAlign: 'middle' }} />)}</li>
              <li>{t.install.iosStep3(appName)}</li>
            </ol>
          </>
        ) : (
          <>
            <p>{t.install.otherIntro}</p>
            <ol className="stack" style={{ paddingLeft: 20, margin: 0 }}>
              <li>{t.install.otherStep1}</li>
              <li>{t.install.otherStep2}</li>
            </ol>
            <p className="muted small">{t.install.otherNote}</p>
          </>
        )}
        <button className="btn btn-primary btn-block" onClick={onClose}>
          {t.install.gotIt}
        </button>
      </div>
    </Modal>
  );
}
